import React from 'react';
import PropTypes from 'prop-types';
import { Select, MenuItem, FormControl } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from 'kangarootime-ui';

// kind of a fork from our kangarootime-ui dropdown
const styles = theme => ({
  formControl: {
    margin: 0,
    fullWidth: true,
    display: 'flex',
    wrap: 'nowrap'
  }
});

const RoomFilter = ({
  rooms,
  onSelect,
  selected,
  ...props
}) => {
  return (
    <FormControl className={props.classes.formControl}>
      <Typography type='meta'>Classroom</Typography>
      <Select
        disableUnderline
        value={selected}
        onChange={event => onSelect(event)}
        style={{ width: 180, border: '1px solid #D7DAE2', borderRadius: 2, padding: 6 }}
      >
        <MenuItem value='all'>All</MenuItem>
        { rooms.map((option, index) => <MenuItem key={index} value={option.id}>{option.name}</MenuItem>)}
      </Select>
    </FormControl>
  );
};

RoomFilter.propTypes = {
  rooms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })),
  onSelect: PropTypes.func,
  selected: PropTypes.oneOfType(PropTypes.string, PropTypes.number) // selected room id
};

export default withStyles(styles)(RoomFilter);
